/** @format */

import React from 'react'

import {
  ContextModal,
  useModalContext,
} from '@src/components/tailwind/ModalContext'

import {FieldTypePicker} from './FieldTypePicker'
import {FieldTypeSettings} from './FieldTypeSettings'
import {State, useAddFieldState} from './useAddFieldState'

export const ADD_FIELD_MODAL_ID = 'valiation.add-field'

type AddFieldModalProps = {
  onSuccess: (fieldName: string) => void
}

export function AddFieldModal(props: AddFieldModalProps) {
  const [state, dispatch] = useAddFieldState()
  const {closeCurrentModal} = useModalContext()
  const modalTitle = getModalTitle(state)

  return (
    <ContextModal
      modal={ADD_FIELD_MODAL_ID}
      title={modalTitle}
      onDidClose={() => dispatch({is: 'Reset'})}
    >
      {/* TODO lazy load modal content, show skeleton */}
      {state.step === 'Choose type to add' ? (
        <FieldTypePicker
          onSelect={selection => {
            dispatch({
              is: 'Select field type',
              params: {fieldType: selection},
            })
          }}
        />
      ) : (
        <FieldTypeSettings
          type={state.fieldType.key}
          onSuccess={fieldName => {
            props.onSuccess(fieldName)
            closeCurrentModal()
          }}
        />
      )}
    </ContextModal>
  )
}

function getModalTitle(state: State): string {
  switch (state.step) {
    case 'Choose type to add':
      return 'Add validation for a form field'
    case 'Configure validation parameters':
      return `Add ${state.fieldType.displayName} Field`
    default:
      const exhaustiveCheck: never = state
      throw new Error(`Unhandled state="${exhaustiveCheck}"`)
  }
}
